export const ADDRESS_NOT_VALID_EVENT = 'cart-address-not-valid';
export const BRIDGER_PAY_VALIDATION_EVENT = 'BRIDGER_PAY_VALIDATION_EVENT';

export const sendCartEvent = (eventName: string, eventDetails?: any) => {
    document.dispatchEvent(new CustomEvent(eventName, {
        detail: eventDetails,
    }));
};